import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
// Importo la configurazione i18n
import "./i18n/index.ts";

import { Toaster } from "react-hot-toast";
import { QueryProvider } from "./components/providers/QueryProvider.tsx";
import { AuthProvider } from "./components/providers/AuthProvider.tsx";
import { WelcomeProvider } from "./components/providers/WelcomeProvider.tsx";
import { ModalsProvider } from "./components/providers/ModalsProvider.tsx";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryProvider>
      <AuthProvider>
        <WelcomeProvider>
          <ModalsProvider>
            <Toaster
              position="bottom-right"
              toastOptions={{
                className: "",
                style: {
                  background: "#2D1B4E",
                  color: "#fff",
                  border: "1px solid #6E11B04D",
                  borderRadius: "16px",
                  fontSize: "14px",
                  padding: "12px 24px",
                },
                success: {
                  duration: 4000,
                  iconTheme: {
                    primary: "#ff7c67",
                    secondary: "#fff",
                  },
                },
                error: {
                  duration: 6000,
                  iconTheme: {
                    primary: "#ef4444",
                    secondary: "#fff",
                  },
                },
              }}
            />
            <App />
          </ModalsProvider>
        </WelcomeProvider>
      </AuthProvider>
    </QueryProvider>
  </React.StrictMode>
);
